import React, { useState, useEffect } from 'react'
import './Work.scss'
import { AiFillEye, AiFillGithub } from 'react-icons/ai'
import { HiOutlineExternalLink } from 'react-icons/hi'
import { AppWrap, MotionWrap } from '../../wrapper'
import { urlFor, client } from '../../client'

const Work = () => {
  // const [activeFilter, setActiveFilter] = useState('All');
  // eslint-disable-next-line no-unused-vars
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);

  useEffect(() => {
    // Fetch works sorted by order (lower first); items without order go last
    const query = '*[_type == "works"] | order(coalesce(order, 999) asc, _createdAt asc)';

    client.fetch(query)
      .then((data) => {
        if (data && Array.isArray(data)) {
          const byTitle = new Map();
          data.forEach((work) => {
            const titleKey = (work.title || work._id || '').trim().toLowerCase();
            if (titleKey && !byTitle.has(titleKey)) {
              byTitle.set(titleKey, work);
            }
          });
          const unique = Array.from(byTitle.values());
          setWorks(unique);
          setFilterWork(unique);
        }
      })
      .catch((err) => {
        console.error('Error fetching works:', err);
      });
  }, [])
  
  // const handleWorkFilter = (item) => {
  //   setActiveFilter(item);
  //   
  //   if (item === 'All') {
  //     setFilterWork(works);
  //   } else {
  //     setFilterWork(works.filter((work) => work.tags && work.tags.includes(item)));
  //   }
  // }

  // const filters = ['All', 'UI/UX', 'Web App', 'Mobile App'];

  return (
    <div className="work__container">
      {/* Header */}
      <div className="work__header">
        <h2 className="work__title">
          Creative <span>Portfolio</span>
        </h2>
        {/* <p className="work__subtitle">
          Exploring innovative solutions through design and code
        </p> */}
      </div>

      {/* Filter Pills */}
      {/* <div className="work__filters">
        {filters.map((item, index) => (
          <button
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`work__filter-btn ${activeFilter === item ? 'active' : ''}`}
          >
            {item}
          </button>
        ))}
      </div> */}

      {/* Projects Grid */}
      <div className="work__grid">
        {filterWork.map((work, index) => (
          <article
            key={work._id || index}
            className="work__item"
            onClick={() => work.projectLink && window.open(work.projectLink, '_blank', 'noopener,noreferrer')}
            style={{ cursor: work.projectLink ? 'pointer' : 'default' }}
          >
            {/* Number */}
            <div className="work__item-number">
              {String(index + 1).padStart(2, '0')}
            </div>

            {/* Content Row */}
            <div className="work__item-main">
              {/* Image */}
              <div className="work__item-image">
                {work.imgUrl && <img src={urlFor(work.imgUrl)} alt={work.title || 'Project'} />}
                
                {/* Quick Actions */}
                <div className="work__item-actions">
                  {work.projectLink && (
                    <a
                      href={work.projectLink}
                      target="_blank"
                      rel="noreferrer"
                      className="work__action"
                      title="View Project"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <AiFillEye />
                    </a>
                  )}
                  {work.codeLink && (
                    <a
                      href={work.codeLink}
                      target="_blank"
                      rel="noreferrer"
                      className="work__action"
                      title="View Code"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <AiFillGithub />
                    </a>
                  )}
                </div>
              </div>

              {/* Info */}
              <div className="work__item-info">
                <div className="work__item-header">
                  <h3 className="work__item-title">{work.title || 'Untitled Project'}</h3>
                  <span className="work__item-arrow">
                    <HiOutlineExternalLink />
                  </span>
                </div>

                <p className="work__item-description">{work.description || ''}</p>

                {/* Tags */}
                {work.tags && work.tags.length > 0 && (
                  <div className="work__item-tags">
                    {work.tags.slice(0, 3).map((tag, tagIndex) => (
                      <span 
                        key={tagIndex} 
                        className="work__tag"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Bottom accent line */}
            <div className="work__item-line" />
          </article>
        ))}
      </div>

      {/* Empty state */}
      {filterWork.length === 0 && (
        <div className="work__empty">
          <p>No projects found for this filter.</p>
        </div>
      )}
    </div>
  )
}
  
export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'work',
  'app__primarybg'
);
